import { createClient } from '@supabase/supabase-js';

// Use REACT_APP_ prefix for Create React App
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log('🔧 Supabase Config:', {
  url: supabaseUrl,
  hasKey: !!supabaseAnonKey,
  nodeEnv: process.env.NODE_ENV
});

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables!');
  console.error('Available env vars:', Object.keys(process.env).filter(k => k.startsWith('REACT_APP_')));
  throw new Error('Missing Supabase environment variables');
}

// On native the OAuth redirect comes back via a deep link (linksy://auth-callback)
// which we exchange manually, so disable auto URL detection there.
const isNativePlatform =
  typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.() === true;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: !isNativePlatform,
  },
});

console.log('✅ Supabase client created', { native: isNativePlatform });